<template>
<div>
  <b-card
      no-body
      class="card-statistics"
  >
    <b-card-header>
      <b-card-title>گزارش غذایی دریافتی</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-overlay
          :show="loading"
          rounded="sm"
      >
        <b-row>
          <b-col
              v-for="item in statisticsItems"
              xl="2"
              md="auto"
              sm="6"
              class="mt-2"
          >
            <b-media
                no-body
            >
              <b-media-aside
                  class="mr-1"
              >
                <b-avatar
                    size="40"
                    :variant="item.color"
                >
                  <feather-icon
                      size="20"
                      :icon="item.icon"
                  />
                </b-avatar>
              </b-media-aside>
              <b-media-body class="my-auto">
                <h4 class="font-weight-bolder mb-0">
                  {{ item.title  }}
                </h4>
                <b-card-text class="font-small-3 mb-0" style="font-size: 12px !important;">
                  {{ item.subtitle }}
                </b-card-text>
              </b-media-body>
            </b-media>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card-body>
  </b-card>
  <div class="d-flex justify-content-between flex-wrap">
    <template v-for="planFood in planFoods">
      <b-card
          :title="planFood.Title"
          bg-variant="light"
          style="width:49%;"
      >
        <div class="d-flex flex-wrap ">
          <b-media
              no-body
              class="mr-3"
          >
            <b-media-aside
                class="mr-1"
            >
              <b-avatar
                  size="40"
                  variant="success"
              >
                <feather-icon
                    size="20"
                    icon=""
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{planFood.MaxCalorie}}
              </h4>
              <b-card-text class="font-small-3 mb-0" style="font-size: 12px !important;">
                کالری که باید دریافت کند
              </b-card-text>
            </b-media-body>
          </b-media>
          <b-media
              no-body
          >
            <b-media-aside
                class="mr-1"
            >
              <b-avatar
                  size="40"
                  variant="primary"
              >
                <feather-icon
                    size="20"
                    icon=""
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{planFood.UsedCalorie}}
              </h4>
              <b-card-text class="font-small-3 mb-0" style="font-size: 12px !important;">
                کالری که دریافت کرده
              </b-card-text>
            </b-media-body>
          </b-media>
        </div>
        <b-card-body>
          <div
              style="width:100%;overflow-x: auto;"
              class="c-scroll"
          >
            <div
                class="d-flex"
                style="width:fit-content"
            >
              <template v-for="food in planFood.Food">
                <b-card
                    border-variant="info"
                    style="width:120px;padding:10px"
                    no-body
                    class="mr-1 text-center card-meal mt-auto"
                >
                  <strong class="text-bold">
                    {{ food.Title }}
                  </strong>
                  <div>
                    <hr>
                  </div>
                  <p class="mb-1 bg-light-info">
                    {{ food.Consumption }}
                  </p>
                  <div class="d-flex justify-content-between">
                    <div class="text-center">
                      <p> {{ food.Calorie }} </p>
                      <p class="text-center">
                        کالری
                      </p>
                    </div>
                    <div class="text-center">
                      <p>{{ food.Gram }}</p>
                      <p>گرم </p>
                    </div>
                  </div>
                </b-card>
              </template>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </template>
  </div>
</div>
</template>
<script>
export default {
  name: 'FoodSchedule',
  props: {
    dietInDate: { type: String, default: '' },
    userId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      planFoods: [],
      message: null,
      statisticsItems:[],
      loading:false,
    }
  },
  watch: {
    dietInDate() {
      this.userPlanFood()
    },
  },
  created() {
    this.userPlanFood()
  },
  methods: {
    userPlanFood() {
      this.loading = true
      this.$http.post(this.$api.userPlanFood.get, {
        FromDate: this.dietInDate,
        ToDate: this.dietInDate,
        UserId: this.userId,
      }).then(res => {
        if (res.data.length){
          this.planFoods = res.data[0].FoodMeal
        }
        this.statisticsItems = [
 {
            icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].TotalCalorie ,
            subtitle: 'جمع کالری',
          },
{
            icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].TotalCarbohydrate ,
            subtitle: ' کربوهیدارت',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].TotalFat ,
            subtitle: 'چربی',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].TotalProtein ,
            subtitle: 'پروتئین',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].UsedCalorie ,
            subtitle: 'کالری دریافتی',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].UsedCarbohydrate ,
            subtitle: 'کربوهیدرات دریافتی',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].UsedFat ,
            subtitle: 'چربی دریافتی',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].UsedProtein ,
            subtitle: 'پروتئین دریافتی',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].UserDietFastDay ,
            subtitle: 'روز رژیم فست',
          },
{
  icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].WaterCount ,
            subtitle: 'آب شمار',
          },
          {
            icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].Ramezan?'دارد':'ندارد'  ,
            subtitle: 'رمضان',
          },
          {
            icon: 'CheckCircleIcon',
            color: 'light-primary',
            title: res.data[0].StepCount ,
            subtitle: 'قدم شمار',
          },
        ]
      }).finally(()=>{
        this.loading = false
      })
    },
  },
}
</script>
  <style scoped lang="scss">
    .card-meal{
    p{
    padding:0;
    margin:0;
    }
    }
</style>
